import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

const options = {
	api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	defaults: '2026-01-30',
} as const

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<HelmetProvider>
			<PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN} options={options}>
				<App />
			</PostHogProvider>
		</HelmetProvider>
	</StrictMode>,
)
